import { Link } from "@tanstack/react-router";
import { type Api } from "api-client";
import { format } from "date-fns";
import { cn } from "ui";

import { NotificationItemMenu } from "src/components/NotificationItemMenu";
import { NotificationMessage } from "src/notifications/NotificationMessage";
import type { NotificationLinkOptions } from "src/notifications/Notifications";

interface NotificationItemProps {
  notification: Api.GetAllNotifications.Output.Notification;
  linkOptions: NotificationLinkOptions | null;
  onClick(event: React.MouseEvent): void;
}

export function NotificationItem(props: NotificationItemProps) {
  const notification = props.notification;
  const className = cn(
    "flex items-start gap-4 p-4 cursor-pointer hover:bg-slate-50",
    { "bg-slate-50": !notification.read },
  );
  const content = (
    <>
      <div className="flex-1">
        <div
          className={cn("flex flex-col justify-between", {
            "opacity-30": notification.read,
          })}
        >
          <p className={`text-sm ${!notification.read ? "font-semibold" : ""}`}>
            <NotificationMessage notification={notification} />
          </p>
          <span className="text-xs text-slate-500">
            {format(new Date(notification.createdAt), "HH:mm MMM dd")}
          </span>
        </div>
      </div>
      {!notification.read && (
        <div className="mt-1 h-2 w-2 rounded-full bg-blue-500" />
      )}
    </>
  );

  return (
    <div className="group relative border-b last:border-b-0">
      {props.linkOptions ? (
        <Link
          {...props.linkOptions}
          className={className}
          onClick={props.onClick}
          onAuxClick={props.onClick}
        >
          {content}
        </Link>
      ) : (
        <div className={className} onClick={props.onClick}>
          {content}
        </div>
      )}
      <NotificationItemMenu notification={notification} />
    </div>
  );
}
